import "./styles/index.scss";
import { cssVarSupport } from "./scripts/browser-helper";
import { handleCookies } from "./scripts/cookies-helper";

cssVarSupport();
handleCookies();
